export class PessoaJuridicaSisbi {
    idPessoaJuridica: number;
    nmFantasia: string;
    nmRazaoSocial: string;
    nrCnpj: string;
    nrInscricaoEstadual: string;


    /**
     * Converte um objeto json em instancias da classe
     */
    static fromJson(jsonData: any): PessoaJuridicaSisbi {
        return Object.assign(new PessoaJuridicaSisbi(), jsonData);
    }
}
